import React from 'react';
import CouponList from '../CouponList';

const WangyuCouponLeftTabItem = ({
  guestInfo,
  basicCardInfo,
  dataSource,
  loading,
  onSave,
  onSortChange,
  onGiveCouponClose,
  onCouponTabChange,
}) => {
  return (
    <CouponList
      guestInfo={guestInfo}
      basicCardInfo={basicCardInfo}
      dataSource={dataSource}
      loading={loading}
      onSave={onSave}
      onSortChange={onSortChange}
      onGiveCouponClose={onGiveCouponClose}
      onCouponTabChange={onCouponTabChange}
    />
  );
};

export default WangyuCouponLeftTabItem;
